// extracted by mini-css-extract-plugin
export default {"about":"about_about__bZBiN","title":"about_title__-o52S","description":"about_description__RdYuZ","subtitle":"about_subtitle__svNls","principles":"about_principles__R0oFS"};